import React from 'react'
import goto from '../../../img_4/goto.png'
import backHome from '../../../img_4/home.png'
import './Navlist.css'

export default function Navlist({ flag, setflag, gamecata }) {
  const setDis = () => {
    setflag(!flag)
  }

  /* 跳转到分类页面 */
  //   const goCate = (para) => {
  //     window.location = "/page/category?type=" + para;
  //   };

  //   const goHome = () => {
  //     window.location = "/";
  //   };

  return (
    <div className={flag ? 'header-nav4' : 'header-nav4 nav-remove'} onClick={setDis}>
      <div>
        {/* 列表 */}
        <ul>
          <li>
            <a href="/" className="dis_a">
              <p>Home</p>
              <img src={backHome} alt="" />
            </a>
          </li>
          {gamecata?.map(item => (
            <li key={item.name}>
              <a href={'/page/category?type=' + item.type} className="dis_a">
                <p>{item.name}</p>
                <img src={goto} alt="" />
              </a>
            </li>
          ))}
          <li
            onClick={() => {
              window.location = '/randomhow/index.html'
            }}
          >
            <p>RandomHow</p>
            <img src={goto} alt="" />
          </li>
        </ul>
      </div>
    </div>
  )
}
